import { RxCross1 } from 'react-icons/rx';

const CrossButton = (props) => (
  <button className="cross-theme-500 p-4 rounded-full text-white z-20" {...props}>
    <RxCross1 className="icon text-2xl" />
  </button>
);

export default CrossButton;
